module.exports = __webpack_public_path__ + "img/EC2.45ea5b9e.png";